export const FILL_LIST = 'FILL_LIST';
export const FILL_ONE = 'FILL_ONE';
export const SET_DETECTION_OF_CHANGES = 'SET_DETECTION_OF_CHANGES';
